// extracted by mini-css-extract-plugin
export var addButton = "_g7-0";
export var border = "_g7-8";
export var check = "_g7-h";
export var danger = "_g7-6";
export var dropdownContainer = "_g7-1";
export var editModalBody = "_g7-j";
export var footerContainer = "_g7-i";
export var fullWidth = "_g7-a";
export var hide = "_g7-9";
export var icon = "_g7-3";
export var input = "_g7-7";
export var inputFlex = "_g7-b";
export var inputWrapper = "_g7-c";
export var manualFocus = "_g7-5";
export var optionButton = "_g7-4";
export var pillWrapper = "_g7-e";
export var pointer = "_g7-2";
export var showOverflow = "_g7-f";
export var tagsFlex = "_g7-d";
export var xButton = "_g7-g";